import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=97ff8c68"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"
import style0 from "./BaseAvatar.vue?vue&type=style&index=0&id=97ff8c68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports